import styled from 'styled-components';

export const Main = styled.main`
  flex: 1 0 auto;
  margin-top: 48px;
  height: calc(100vh - 48px);
  width: auto;
  background-color:rgb(255,255,255) !important;
  overflow-y: auto;
  scrollbar-gutter: stable;

  .ms-Stack {
    row-gap: 10px;
    column-gap: 10px;
    &.Container {
      margin-top: 48px;
      margin-bottom: 48px;
      margin-left: 48px;
      margin-right: 5%;
    }
  }

  .ms-StackItem {
    margin-right: auto;
  }

  .ms-Button {
    margin-right: auto;
  }

  .ms-Spinner {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 9999999;
    background-color: rgb(0, 0, 0, 0.3);
  }

  @media (max-width: 768px) {
    &.navCollapsed,
    &.navExpanded {
      margin-left: 0;
      width: 100%;
    }

    .ms-Stack {
      &.Container {
        margin-left: 16px;
        margin-right: 16px;
      }
    }
  }

  @media (max-width: 1024px) {
    &.navExpanded {
      margin-left: 220px;
      width: calc(100% - 220px);
    }
  }

  @media (min-width: 1025px) {
    &.navCollapsed {
      margin-left: 48px;
      width: calc(100% - 48px);
    }

    &.navExpanded {
      margin-left: 260px;
      width: calc(100% - 260px);
    }
  }
`;
